import React from "react";
import { Link, useLocation } from "react-router-dom";
import { pageURLs } from "@/constants";
import "./AgentDirectoryLink.scss";

export const isDirectoryPath = (pathname = "") =>
  pathname === pageURLs.agentDirectory || pathname.startsWith(`${pageURLs.agentDirectory}/`);

const AgentDirectoryLink = ({ className = "" }) => {
  const { pathname } = useLocation();
  const isHere = isDirectoryPath(pathname);
  return (
    <Link
      to={pageURLs.agentDirectory}
      className={`agent-directory-link${isHere ? " is-here" : ""} ${className}`.trim()}
      aria-current={isHere ? "page" : undefined}
    >
      Agent directory
    </Link>
  );
};

export default AgentDirectoryLink;
